module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copy_referral_details_explanation":"Import Referral Details from linked {organDescription}","referral":"Referral","copy_from":"Copy from"},"fr":{"copy_referral_details_explanation":"Importer les détails de la référence à partir de {organDescription} lié","referral":"Référence","copy_from":"Copier de"}}')
  delete Component.options._Ctor
}
